/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import {useEffect, useRef, useState} from 'react'
import {createPortal} from 'react-dom'
import {Modal, Button} from 'react-bootstrap'
import {defaultCreateAppData, ICreateAppData} from './IAppModels'
import {StepperComponent} from '../../../assets/ts/components'
import {KTIcon} from '../../../helpers'
import {Step1} from './steps/Step1'
// import {Step2} from './steps/Step2'
// import {Step3} from './steps/Step3'
import {Step4} from './steps/Step4'
import {Step5} from './steps/Step5'
import {useAuth, UserModel} from '../../../../app/modules/auth'
import {toast, ToastContainer} from 'react-toastify'
import {IoClose} from 'react-icons/io5'
import {FaArrowRight, FaArrowLeft} from 'react-icons/fa'
import 'react-toastify/dist/ReactToastify.css'
import {useNavigate} from 'react-router-dom'
import {fetchClaimDetails} from '../../../../hooks/useClaims'

type Props = {
  show: boolean
  handleClose: () => void
  claimDetails: any
  formattedDate: string
  onSuccessSubmit: () => void
  monitoringDetailsByYesterday?: any
}

const modalsRoot = document.getElementById('root-modals') || document.body

const CreateAppModal = ({
  show,
  handleClose,
  claimDetails,
  formattedDate,
  onSuccessSubmit,
  monitoringDetailsByYesterday,
}: Props) => {
  const user = useAuth()
  const {auth} = useAuth()
  const navigate = useNavigate()
  const stepperRef = useRef<HTMLDivElement | null>(null)
  const stepper = useRef<StepperComponent | null>(null)
  const [data, setData] = useState<ICreateAppData>(defaultCreateAppData)
  const [hasError, setHasError] = useState(false)
  const [currentStep, setCurrentStep] = useState(0)
  const [curStep, setCurStep] = useState(0)
  const [isStep1Valid, setIsStep1Valid] = useState(false)
  // const [isStep2Valid, setIsStep2Valid] = useState(false)
  // const [isStep3Valid, setIsStep3Valid] = useState(false)
  const [isStep4Valid, setIsStep4Valid] = useState(false)
  const [loading, setLoading] = useState(false)
  const [showConfirmation, setShowConfirmation] = useState(false)

  // Pre-populate form with yesterday's monitoring data if available
  useEffect(() => {
    if (
      show &&
      monitoringDetailsByYesterday &&
      Object.keys(monitoringDetailsByYesterday).length > 0
    ) {
      // Get the actual monitoring detail from the nested structure
      const detailMonitoring =
        monitoringDetailsByYesterday.data?.detailMonitoring || monitoringDetailsByYesterday

      // Create a new object with fields from yesterday's monitoring data
      const yesterdayData = {
        appBasic: {
          ...data.appBasic,
          // Step 1 fields
          icd10: detailMonitoring.icdCode1
            ? `${detailMonitoring.icdCode1} - ${detailMonitoring.icdDesc1 || ''}`
            : data.appBasic.icd10,
          icd102: detailMonitoring.icdCode2
            ? `${detailMonitoring.icdCode2} - ${detailMonitoring.icdDesc2 || ''}`
            : data.appBasic.icd102,
          icd103: detailMonitoring.icdCode3
            ? `${detailMonitoring.icdCode3} - ${detailMonitoring.icdDesc3 || ''}`
            : data.appBasic.icd103,
          icd104: detailMonitoring.icdCode4
            ? `${detailMonitoring.icdCode4} - ${detailMonitoring.icdDesc4 || ''}`
            : data.appBasic.icd104,
          laboratorium: detailMonitoring.laboratory || data.appBasic.laboratorium,
          generalCondition: detailMonitoring.generalCondition || data.appBasic.generalCondition,

          // Step 2 fields
          // doctor: detailMonitoring.doctor || data.appBasic.doctor,
          // specialist: detailMonitoring.specialist || data.appBasic.specialist,
          // medicalExpense: detailMonitoring.medicalExpense || data.appBasic.medicalExpense,
          // upgradeRoom: detailMonitoring.upgradeRoom || data.appBasic.upgradeRoom,
          // reason: detailMonitoring.reason || data.appBasic.reason,
          // isAPS:
          //   detailMonitoring.isAps !== undefined ? detailMonitoring.isAps : data.appBasic.isAPS,
          // costSaving: detailMonitoring.costSaving || data.appBasic.costSaving,
          // remarksCostSaving: detailMonitoring.remarkCostSaving || data.appBasic.remarksCostSaving,
          // costSaving: detailMonitoring.costSaving || data.appBasic.costSaving || 0,
          // remarksCostSaving:
          //   detailMonitoring.remarkCostSaving || data.appBasic.remarksCostSaving || '',

          // Step 3 fields
          // pulse: detailMonitoring.pulse || data.appBasic.pulse,
          // respiratory: detailMonitoring.respiratory || data.appBasic.respiratory,
          // bloodPressure: detailMonitoring.bloodPressure || data.appBasic.bloodPressure,
          // temperature: detailMonitoring.temperature || data.appBasic.temperature,
          // supporting: detailMonitoring.supporting || data.appBasic.supporting,
          // followUp: detailMonitoring.followUp || data.appBasic.followUp,
          // treatment: detailMonitoring.treatment || data.appBasic.treatment,
          // remarks: detailMonitoring.remark || data.appBasic.remarks,
        },
      }

      console.log('Pre-filled data:', yesterdayData)

      setData((prevData) => ({
        ...prevData,
        ...yesterdayData,
      }))
    }
  }, [show, monitoringDetailsByYesterday])

  // Reset state when modal is closed
  useEffect(() => {
    if (!show) {
      // Reset to default values
      setData(defaultCreateAppData)
      setHasError(false)
      setCurrentStep(0)
      setCurStep(0)
      setIsStep1Valid(false)
      // setIsStep2Valid(false)
      // setIsStep3Valid(false)
      setIsStep4Valid(false)
    }
  }, [show])

  // Initialize stepper when modal is shown
  useEffect(() => {
    if (show && stepperRef.current) {
      stepper.current = StepperComponent.createInsance(stepperRef.current)
    }
  }, [show])

  const formatDate = () => {
    return formattedDate
  }

  const loadStepper = () => {
    if (stepperRef.current) {
      stepper.current = StepperComponent.createInsance(stepperRef.current)
    } else {
      console.error('stepperRef.current is null')
    }
  }

  const updateData = (fieldsToUpdate: Partial<ICreateAppData>) => {
    const updatedData = {...data, ...fieldsToUpdate}
    setData(updatedData)
  }

  const checkAppBasic = (): boolean => {
    if (!data.appBasic.appName || !data.appBasic.appType) {
      return false
    }
    return true
  }

  const checkAppDataBase = (): boolean => {
    if (!data.appDatabase.databaseName || !data.appDatabase.databaseSolution) {
      return false
    }

    return true
  }

  const prevStep = () => {
    if (!stepper.current) {
      return
    }
    stepper.current.goPrev()
    setCurrentStep(stepper.current?.currentStepIndex || 0)
  }

  const nextStep = () => {
    setHasError(false)
    if (!stepper.current) {
      return
    }

    stepper.current.goNext()
    setCurrentStep(stepper.current?.currentStepIndex || 0)
  }

  const handleSubmitClick = () => {
    setShowConfirmation(true)
  }

  const submit = async () => {
    setLoading(true)
    try {
      // First, create the monitoring data
      const monitoringResponse = await fetch(
        `${process.env.REACT_APP_API_CLAIM_URL}/api/Claims/DailyMonitoring`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${auth?.token}` || `Bearer ${user.currentUser?.token}`,
          },
          body: JSON.stringify({
            claimNumber: claimDetails.claimDetails.claimNumber,
            monitoringDate: formattedDate,
            icdCode1: data.appBasic.icd10?.split(' - ')[0] || '',
            icdCode2: data.appBasic.icd102?.split(' - ')[0] || '',
            icdCode3: data.appBasic.icd103?.split(' - ')[0] || '',
            icdCode4: data.appBasic.icd104?.split(' - ')[0] || '',
            laboratory: data.appBasic.laboratorium,
            generalCondition: data.appBasic.generalCondition,
            // Step 2 fields (commented out)
            // doctor: data.appBasic.doctor,
            // specialist: data.appBasic.specialist,
            // medicalExpense: data.appBasic.medicalExpense,
            // upgradeRoom: data.appBasic.upgradeRoom,
            // reason: data.appBasic.reason,
            // isAps: data.appBasic.isAPS,
            // costSaving: data.appBasic.costSaving,
            // remarkCostSaving: data.appBasic.remarksCostSaving,
            // Step 3 fields (commented out)
            // pulse: data.appBasic.pulse,
            // respiratory: data.appBasic.respiratory,
            // bloodPressure: data.appBasic.bloodPressure,
            // temperature: data.appBasic.temperature,
            chiefComplain: null,
            vas: null,
            iv: null,
            oral: null,
            // supporting: data.appBasic.supporting,
            // followUp: data.appBasic.followUp,
            // treatment: data.appBasic.treatment,
            // remark: data.appBasic.remarks,
            radiology: null,
            medicine: null,
            focusOfManagement: null,
            username: user.currentUser?.email,
          }),
        }
      )

      if (!monitoringResponse.ok) {
        throw new Error('Failed to create daily monitoring')
      }

      const monitoringData = await monitoringResponse.json()
      const idMonitoring = monitoringData.id

      // Handle file uploads if there are any
      if (data.appFiles?.files?.length > 0) {
        const formData = new FormData()

        data.appFiles.files.forEach((file: File) => {
          formData.append('files', file)
        })

        const uploadUrl = `${process.env.REACT_APP_API_CLAIM_URL}/api/Claims/DailyMonitoringUpload?idMonitoring=${idMonitoring}&claimNumber=${claimDetails.claimDetails.claimNumber}&user=${user.currentUser?.email}`

        const uploadResponse = await fetch(uploadUrl, {
          method: 'POST',
          body: formData,
          headers: {
            Authorization: `Bearer ${auth?.token}` || `Bearer ${user.currentUser?.token}`,
          },
        })

        if (!uploadResponse.ok) {
          throw new Error('Failed to upload files')
        }
      }

      // Only call UpdateStatus API if status is not Daily Monitoring
      if (claimDetails.claimDetails.status !== 'Daily Monitoring') {
        const statusChangeResponse = await fetch(
          `${process.env.REACT_APP_API_CLAIM_URL}/api/Claims/UpdateStatus`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${auth?.token}` || `Bearer ${user.currentUser?.token}`,
            },
            body: JSON.stringify({
              claimNumber: claimDetails.claimDetails.claimNumber,
              status: 'Daily Monitoring',
              username: user.currentUser?.email,
              source: 'Provider',
            }),
          }
        )

        if (!statusChangeResponse) {
          console.warn('Failed to update status to Daily Monitoring')
        }
      }

      // Fetch updated claim details after successful upload
      const token = auth?.token || user.currentUser?.token
      if (token) {
        try {
          const updatedClaimDetails = await fetchClaimDetails(
            claimDetails.claimDetails.claimNumber,
            token
          )
          if (updatedClaimDetails) {
            // Update location state with fresh claim details
            console.log('Updating location state with fresh claim details:', updatedClaimDetails)
            navigate('/inpatient', {state: {claimDetails: updatedClaimDetails}, replace: true})
          }
        } catch (error) {
          console.error('Error fetching updated claim details:', error)
          // Continue with success flow even if fetch fails
        }
      }

      await toast.success('Submission and Upload Successful!', {
        position: 'top-right',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      })

      onSuccessSubmit()
      handleClose()
      setShowConfirmation(false)
    } catch (error) {
      console.error('Error:', error)
      toast.error('Error: ' + (error as Error).message)
      setShowConfirmation(false)
    } finally {
      setLoading(false)
    }
  }

  const handleValidationChange = (isValid: boolean) => {
    setIsStep1Valid(isValid)
  }

  // const handleValidationChange2 = (isValid: boolean) => {
  //   setIsStep2Valid(isValid)
  // }

  // const handleValidationChange3 = (isValid: boolean) => {
  //   setIsStep3Valid(isValid)
  // }

  const handleValidationChange4 = (isValid: boolean) => {
    setIsStep4Valid(isValid)
  }

  useEffect(() => {
    if (!show) {
      setData(defaultCreateAppData)
      setHasError(false)
      setCurrentStep(0)
      setCurStep(0)
    }
  }, [show])

  return createPortal(
    <>
      {/* Main modal - opacity controlled by showConfirmation state */}
      <Modal
        data-testid='create-app-modal'
        id='kt_modal_create_app'
        tabIndex={-1}
        aria-hidden='true'
        dialogClassName='modal-dialog modal-dialog-centered mw-900px'
        show={show}
        onHide={handleClose}
        onEntered={loadStepper}
        backdrop={true}
        style={{
          opacity: showConfirmation ? 0 : 1,
          transition: 'opacity 0.2s ease-in-out',
        }}
      >
        {/* Main modal content */}
        <div
          className='modal-header'
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <div style={{display: 'flex', alignItems: 'center', gap: '10px'}}>
            <span style={{color: 'gray', fontSize: '16px'}}>{formatDate()} </span>
            <h2 style={{margin: 0}}>Create Monitoring</h2>
          </div>
          <div
            className='btn btn-sm btn-icon btn-active-color-primary'
            onClick={handleClose}
            style={{
              marginLeft: 'auto',
              cursor: 'pointer',
            }}
          >
            <IoClose className='fs-1' />
          </div>
        </div>

        <div className='modal-body py-lg-10 px-lg-10'>
          {/*begin::Stepper */}
          <div
            ref={stepperRef}
            className='stepper stepper-pills stepper-column d-flex flex-column flex-xl-row flex-row-fluid'
            id='kt_modal_create_app_stepper'
          >
            {/* begin::Aside*/}
            <div className='d-flex justify-content-center justify-content-xl-start flex-row-auto w-100 w-xl-300px'>
              {/* begin::Nav*/}
              <div className='stepper-nav ps-lg-10'>
                {/* begin::Step 1*/}
                <div className='stepper-item current' data-kt-stepper-element='nav'>
                  {/* begin::Wrapper*/}
                  <div className='stepper-wrapper'>
                    {/* begin::Icon*/}
                    <div className='stepper-icon w-40px h-40px'>
                      <i className='stepper-check fas fa-check'></i>
                      <span className='stepper-number'>1</span>
                    </div>
                    {/* end::Icon*/}

                    {/* begin::Label*/}
                    <div className='stepper-label'>
                      <h3 className='stepper-title'>Diagnosis</h3>
                    </div>
                    {/* end::Label*/}
                  </div>
                  {/* end::Wrapper*/}

                  {/* begin::Line*/}
                  <div className='stepper-line h-40px'></div>
                  {/* end::Line*/}
                </div>
                {/* end::Step 1*/}

                {/* begin::Step 2*/}
                {/* <div className='stepper-item' data-kt-stepper-element='nav'> */}
                  {/* begin::Wrapper*/}
                  {/* <div className='stepper-wrapper'> */}
                    {/* begin::Icon*/}
                    {/* <div className='stepper-icon w-40px h-40px'> */}
                      {/* <i className='stepper-check fas fa-check'></i> */}
                      {/* <span className='stepper-number'>2</span> */}
                    {/* </div> */}
                    {/* begin::Icon*/}

                    {/* begin::Label*/}
                    {/* <div className='stepper-label'> */}
                      {/* <h3 className='stepper-title'>Information</h3> */}
                    {/* </div> */}
                    {/* begin::Label*/}
                  {/* </div> */}
                  {/* end::Wrapper*/}

                  {/* begin::Line*/}
                  {/* <div className='stepper-line h-40px'></div> */}
                  {/* end::Line*/}
                {/* </div> */}
                {/* end::Step 2*/}

                {/* begin::Step 3*/}
                {/* <div className='stepper-item' data-kt-stepper-element='nav'> */}
                  {/* begin::Wrapper*/}
                  {/* <div className='stepper-wrapper'> */}
                    {/* begin::Icon*/}
                    {/* <div className='stepper-icon w-40px h-40px'> */}
                      {/* <i className='stepper-check fas fa-check'></i> */}
                      {/* <span className='stepper-number'>3</span> */}
                    {/* </div> */}
                    {/* end::Icon*/}

                    {/* begin::Label*/}
                    {/* <div className='stepper-label'> */}
                      {/* <h3 className='stepper-title'>Patient</h3> */}
                    {/* </div> */}
                    {/* end::Label*/}
                  {/* </div> */}
                  {/* end::Wrapper*/}

                  {/* begin::Line*/}
                  {/* <div className='stepper-line h-40px'></div> */}
                  {/* end::Line*/}
                {/* </div> */}
                {/* end::Step 3*/}

                {/* begin::Step 4*/}
                <div className='stepper-item' data-kt-stepper-element='nav'>
                  {/* begin::Wrapper*/}
                  <div className='stepper-wrapper'>
                    {/* begin::Icon*/}
                    <div className='stepper-icon w-40px h-40px'>
                      <i className='stepper-check fas fa-check'></i>
                      <span className='stepper-number'>2</span>
                    </div>
                    {/* end::Icon*/}

                    {/* begin::Label*/}
                    <div className='stepper-label'>
                      <h3 className='stepper-title'>Documents</h3>
                    </div>
                    {/* end::Label*/}
                  </div>
                  {/* end::Wrapper*/}

                  {/* begin::Line*/}
                  <div className='stepper-line h-40px'></div>
                  {/* end::Line*/}
                </div>
                {/* end::Step 2*/}
              </div>
              {/* end::Nav*/}
            </div>
            {/* begin::Aside*/}

            {/*begin::Content */}
            <div className='flex-row-fluid py-lg-5 px-lg-15'>
              {/*begin::Form */}
              <form noValidate id='kt_modal_create_app_form'>
                <Step1
                  data={data}
                  updateData={updateData}
                  hasError={hasError}
                  onValidationChange={handleValidationChange}
                  claimDetails={claimDetails}
                />
                {/* <Step2
                  data={data}
                  updateData={updateData}
                  hasError={hasError}
                  onValidationChange={handleValidationChange2}
                />
                <Step3
                  data={data}
                  updateData={updateData}
                  hasError={hasError}
                  onValidationChange={handleValidationChange3}
                /> */}
                <Step4 data={data} updateData={updateData} hasError={hasError} onValidationChange={handleValidationChange4} />
                <Step5 />

                {/*begin::Actions */}
                <div className='d-flex flex-stack pt-10'>
                  <div className='me-2'>
                    <button
                      type='button'
                      className='btn btn-lg btn-light-primary me-3'
                      data-kt-stepper-action='previous'
                      onClick={prevStep}
                    >
                      <FaArrowLeft className='me-1' /> Previous
                    </button>
                  </div>
                  <div>
                    <button
                      type='button'
                      className='btn btn-lg btn-primary'
                      data-kt-stepper-action='submit'
                      onClick={handleSubmitClick}
                      disabled={loading || !isStep4Valid}
                    >
                      {loading ? (
                        <span>
                          <span
                            className='spinner-border spinner-border-sm'
                            role='status'
                            aria-hidden='true'
                          ></span>{' '}
                          Submitting...
                        </span>
                      ) : (
                        <>
                          Submit <FaArrowRight className='ms-2 me-0' />
                        </>
                      )}
                    </button>

                    {currentStep === 0 && (
                      <button
                        type='button'
                        className='btn btn-lg btn-primary'
                        data-kt-stepper-action='next'
                        onClick={nextStep}
                        disabled={!isStep1Valid}
                      >
                        Next <FaArrowRight className='ms-1 me-0' />
                      </button>
                    )}

                    {currentStep === 1 && (
                      <button
                        type='button'
                        className='btn btn-lg btn-primary'
                        data-kt-stepper-action='next'
                        onClick={nextStep}
                        disabled={!isStep1Valid}
                      >
                        Next <FaArrowRight className='ms-1 me-0' />
                      </button>
                    )}

                    {/* {currentStep === 2 && (
                      <button
                        type='button'
                        className='btn btn-lg btn-primary'
                        data-kt-stepper-action='next'
                        onClick={nextStep}
                        disabled={!isStep2Valid}
                      >
                        Next <FaArrowRight className='ms-1 me-0' />
                      </button>
                    )}

                    {currentStep === 3 && (
                      <button
                        type='button'
                        className='btn btn-lg btn-primary'
                        data-kt-stepper-action='next'
                        onClick={nextStep}
                        disabled={!isStep3Valid}
                      >
                        Next <FaArrowRight className='ms-1 me-0' />
                      </button>
                    )} */}
                  </div>
                </div>
                {/*end::Actions */}
              </form>
              {/*end::Form */}
            </div>
            {/*end::Content */}
          </div>
          {/* end::Stepper */}
        </div>
      </Modal>

      {/* Confirmation modal - only shown when showConfirmation is true */}
      <Modal
        show={showConfirmation}
        onHide={() => setShowConfirmation(false)}
        centered
        backdrop='static'
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Are you sure you want to submit this daily monitoring?</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant='secondary' onClick={() => setShowConfirmation(false)}>
            Cancel
          </Button>
          <Button variant='primary' onClick={submit} disabled={loading}>
            {loading ? (
              <span>
                <span
                  className='spinner-border spinner-border-sm'
                  role='status'
                  aria-hidden='true'
                ></span>{' '}
                Submitting...
              </span>
            ) : (
              'Submit'
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      <ToastContainer
        position='top-right'
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme='light'
      />
    </>,
    modalsRoot
  )
}

export {CreateAppModal}
